import { Room } from '../types';

/** Canonical RENT | ADVANCE | DEPOSIT | REFUND (handles legacy casing / labels). */
export function normalizePaymentType(value: unknown): string {
  const s = String(value ?? 'RENT')
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_');
  if (!s) return 'RENT';
  if (s === 'RENT' || s.startsWith('RENT')) return 'RENT';
  if (s === 'ADVANCE' || s === 'ADV' || s.startsWith('ADVANC')) return 'ADVANCE';
  if (s === 'DEPOSIT' || s.startsWith('DEPOSIT')) return 'DEPOSIT';
  if (s === 'REFUND' || s.startsWith('REFUND')) return 'REFUND';
  if (s === 'GUEST_STAY' || s.includes('GUEST')) return 'GUEST_STAY';
  return s;
}

export function paymentTypeLabel(value: unknown): string {
  const key = normalizePaymentType(value);
  if (key === 'RENT') return 'Rent';
  if (key === 'ADVANCE') return 'Advance';
  if (key === 'DEPOSIT') return 'Deposit';
  if (key === 'REFUND') return 'Refund';
  if (key === 'GUEST_STAY') return 'Guest';
  return key;
}

export function recordRoomLabel(
  room: string | undefined,
  roomById: Record<number, Room>
): string {
  const rid = room != null && String(room).trim() !== '' ? Number(room) : NaN;
  if (Number.isFinite(rid) && roomById[rid] != null) return String(roomById[rid].roomNumber);
  return String(room ?? '').trim();
}

export function recordMatchesSearch(
  q: string,
  fields: { name?: string; phone?: string; room?: string }
): boolean {
  const name = (fields.name || '').toLowerCase();
  const phone = (fields.phone || '').toLowerCase();
  const room = (fields.room || '').toLowerCase();
  return name.includes(q) || phone.includes(q) || room.includes(q);
}
